import { useState } from 'react';
import Icon from './Icon';
import { faqs } from '../constants/content';

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="section section--alt" id="faq">
      <div className="container container--narrow">
        <div className="sec-head sec-head--center">
          <p className="kicker">Answers</p>
          <h2 className="sec-title">Common Questions About McAfee</h2>
          <p className="sec-lead">
            Everything people ask before they buy. If yours is not here, our team is one call away.
          </p>
        </div>

        <div className="faq">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            const panelId = `faq-panel-${index}`;

            return (
              <div key={item.q} className={`faq__item${isOpen ? ' is-open' : ''}`}>
                <button
                  type="button"
                  className="faq__btn"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  aria-expanded={isOpen}
                  aria-controls={panelId}
                >
                  <span>{item.q}</span>
                  <Icon name="chevron" size={20} strokeWidth={2.2} className="faq__chev" />
                </button>
                {isOpen && (
                  <div className="faq__answer" id={panelId}>
                    {item.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
